import { render } from "./PersonalityMatrixChart.vue?vue&type=template&id=2a715c10&scoped=true"
import script from "./PersonalityMatrixChart.vue?vue&type=script&lang=ts"
export * from "./PersonalityMatrixChart.vue?vue&type=script&lang=ts"

import "./PersonalityMatrixChart.vue?vue&type=style&index=0&id=2a715c10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a715c10"

export default script